import { render } from "./vmenuedit.vue?vue&type=template&id=5199c6a7&scoped=true"
import script from "./vmenuedit.vue?vue&type=script&lang=js"
export * from "./vmenuedit.vue?vue&type=script&lang=js"

import "./vmenuedit.vue?vue&type=style&index=0&id=5199c6a7&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5199c6a7"]])

export default __exports__